import React from 'react';

const SidebarWidgetList = ({ widgets, visibleWidgets, onToggleVisibility }) => {
  return (
    <div className="space-y-1 max-h-[calc(100vh-280px)] overflow-y-auto pr-1">
      {widgets.map((widget, index) => (
        <div
          key={widget.id}
          className={`group flex items-center p-2.5 rounded-lg transition-all ${
            visibleWidgets.includes(widget.id)
              ? 'bg-gray-50 text-primary'
              : 'hover:bg-gray-50 text-gray-500'
          }`}
        >
          <div className="flex items-center flex-1 min-w-0">
            <div
              className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mr-3 ${
                visibleWidgets.includes(widget.id)
                  ? 'bg-primary text-white'
                  : 'bg-gray-200 text-gray-500'
              }`}
            >
              <span className="text-xs font-medium">{index + 1}</span>
            </div>

            <div className="flex-1 min-w-0">
              <label
                htmlFor={`widget-${widget.id}`}
                className={`text-sm cursor-pointer truncate block ${
                  visibleWidgets.includes(widget.id) ? 'font-medium' : 'font-normal'
                }`}
              >
                {widget.title}
              </label>
            </div>
          </div>

          <input
            type="checkbox"
            id={`widget-${widget.id}`}
            checked={visibleWidgets.includes(widget.id)}
            onChange={() => onToggleVisibility(widget.id)}
            className="ml-2 h-4 w-4 rounded border-gray-300 text-primary focus:ring-primaryDark"
          />
        </div>
      ))}
    </div>
  );
};

export default SidebarWidgetList;